/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  MenuItemsType,
  DropdownMenuItemType,
  SwapIcon,
  SwapFillIcon,
  EarnFillIcon,
  EarnIcon,
  TrophyIcon,
  TrophyFillIcon,
  NftIcon,
  NftFillIcon,
  MoreIcon,
  FarmIcon,
  HomeIcon,
} from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'
import { nftsBaseUrl } from 'views/Nft/market/constants'
import { perpLangMap } from 'utils/getPerpetualLanguageCode'
import { perpTheme } from 'utils/getPerpetualTheme'
import { DropdownMenuItems } from '@pancakeswap/uikit/src/components/DropdownMenu/types'
import { ChainId } from '@pancakeswap/sdk'

export type ConfigMenuDropDownItemsType = DropdownMenuItems & { hideSubNav?: boolean }
export type ConfigMenuItemsType = Omit<MenuItemsType, 'items'> & { hideSubNav?: boolean } & {
  items?: ConfigMenuDropDownItemsType[]
}

const filterItemBySupportChainId = (item, chainId) => {
  return !chainId || !item.supportChainIds ? true : item.supportChainIds?.includes(chainId)
}

const config: (
  t: ContextApi['t'],
  isDark: boolean,
  languageCode?: string,
  chainId?: number,
) => ConfigMenuItemsType[] = (t, isDark, languageCode, chainId) =>
  [
    {
      label: t('Trade'),
      icon: SwapIcon,
      fillIcon: SwapFillIcon,
      href: '/swap',
      showItemsOnMobile: true,
      items: [
        {
          label: t('Swap'),
          href: '/swap',
        },
        {
          label: t('Liquidity'),
          href: '/liquidity',
        },
      ].filter((item) => filterItemBySupportChainId(item, chainId)),
    },
    {
      label: t('Farms'),
      href: '/farms',
      icon: FarmIcon,
      fillIcon: FarmIcon,
      showItemsOnMobile: false,
      items: [],
    },
    {
      label: '',
      href: '/voting',
      icon: MoreIcon,
      hideSubNav: true,
      items: [
        {
          label: t('Voting'),
          href: '/voting',
        },
        {
          type: DropdownMenuItemType.DIVIDER,
        },
        {
          label: t('Twitter'),
          href: 'https://twitter.com/mintraio',
          type: DropdownMenuItemType.EXTERNAL_LINK,
        },
        {
          label: t('Telegram'),
          href: 'https://t.me/MintraOfficial',
          type: DropdownMenuItemType.EXTERNAL_LINK,
        },
        {
          label: t('Discord'),
          href: 'https://discord.com/invite/kJYt22ruWp',
          type: DropdownMenuItemType.EXTERNAL_LINK,
        },
      ],
    },
  ].filter((item) => filterItemBySupportChainId(item, chainId))

export default config
